export default __webpack_public_path__ + "static/media/database.580ea27d.svg";